import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { CalendarDays } from "lucide-react";
import { cn } from "../lib/utils";

export const formatPeriodDate = (iso) => {
  if (!iso) return "";
  const d = new Date(`${iso}T00:00:00`);
  return d.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" });
};

export const formatPeriodRange = (start, end) =>
  `${formatPeriodDate(start)} \u2192 ${formatPeriodDate(end)}`;

export const PeriodBadge = ({ className }) => {
  const [period, setPeriod] = useState(null);

  useEffect(() => {
    let mounted = true;
    api
      .get("/period/current")
      .then((res) => mounted && setPeriod(res.data))
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  if (!period) return null;

  return (
    <div
      data-testid="current-period-badge"
      className={cn(
        "inline-flex items-center gap-2 rounded-md border border-border bg-card px-3 py-1.5 text-sm text-muted-foreground",
        className
      )}
    >
      <CalendarDays className="h-4 w-4 text-primary" />
      <span>
        Current accounting period:{" "}
        <span className="font-medium text-foreground">
          {formatPeriodRange(period.week_start, period.week_end)}
        </span>
      </span>
    </div>
  );
};
